export default "__VITE_ASSET__Bmm$0Or5__"